import Vue from 'vue'
import AscGridTooltip from '@/components/molecules/AscGridTooltip'

export default Vue.extend({
  components: {
    AscGridTooltip,
  },

  data: function () {
    return {}
  },

  template: `<asc-grid-tooltip :params="params"/>`,
})
